const flatpickr = require('flatpickr');

// Example class
let _this = (module.exports = {
	// Set the dom elements
	dom: {},

	// Set variables
	vars: {
		optional_config: {
			dateFormat: 'd.m.Y',
			defaultDate: new Date(),
			disableMobile: true,
      minDate: "today",
			onChange: function (selectedDates, dateStr, instance) {
        const eventChange = new Event('change', { bubbles: true });

        const dateObj = dateStr.split('.');
        const day = dateObj[0];
        const month = dateObj[1];
        const year = dateObj[2];

        const dayInput = document.querySelector('input[name="wm_date_day"]');
        const monthInput = document.querySelector('input[name="wm_date_month"]');
        const yearInput = document.querySelector('input[name="wm_date_year"]');

        dayInput.value = day;
        monthInput.value = month;
        yearInput.value = year;

        dayInput.dispatchEvent(eventChange);
        monthInput.dispatchEvent(eventChange);
        yearInput.dispatchEvent(eventChange);

        const dayDisplay = document.querySelector('#date-day .date-input-inner');
        const monthDisplay = document.querySelector('#date-month .date-input-inner');
        const yearDisplay = document.querySelector('#date-year .date-input-inner');

        dayDisplay.textContent = day;
        monthDisplay.textContent = month;
        yearDisplay.textContent = year;

			},
		},
	},
	/**
	 * Init functions
	 */
	init: function () {
		flatpickr('#wm_date', _this.vars.optional_config);
    
	},
});
